// WhatsAppButton.jsx
import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = "+96893579571"; 
  const message = "Hello, I would like to contact you!";

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <img
        src="/img/icons/whatsapp.svg" 
        alt="WhatsApp"
        className="w-12 h-12"
        style={{ width:"50px" }}
      />
    </a>
  );
};

export default WhatsAppButton;
